export default __webpack_public_path__ + "static/media/image_demo_lab_testing.29504b87.svg";